import { Container } from '@/components/ui/Container'
import { Section } from '@/components/ui/Section'
import { ContactHeroSection } from './components/ContactHeroSection'
import { ContactInfoSection } from './components/ContactInfoSection'
import { ContactFormSection } from './components/ContactFormSection'

export function ContactFeature() {
  return (
    <>
      <ContactHeroSection />
      <Section surface="0" withBorder className="pt-0 md:pt-0">
        <Container>
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 sm:gap-12 items-start">
            {/* Left: Contact Information & Channels */}
            <div className="lg:col-span-5">
              <ContactInfoSection />
            </div>

            {/* Right: Interactive Contact Form */}
            <div className="lg:col-span-7">
              <ContactFormSection />
            </div>
          </div>
        </Container>
      </Section>
    </>
  )
}
